import PlayButton, { PlayButtonProps } from "@/components/PlayButton";
import { NextMention, PreviousMention } from "@/Icons";
import Clickable from "@components/Clickable";

import styles from "./PlayButtonWithControls.module.css";

export type PlayButtonWithControlsProps = {
  previousDisabled?: boolean;
  nextDisabled?: boolean;
  onClickPrevious?: () => void;
  onClickNext?: () => void;
} & PlayButtonProps;

const PlayButtonWithControls: React.FunctionComponent<
  PlayButtonWithControlsProps
> = ({
  previousDisabled = false,
  nextDisabled = false,
  onClickPrevious = () => null,
  onClickNext = () => null,
  ...props
}) => {
  return (
    <div className={styles.root}>
      <PlayButton {...props} />
      {(!previousDisabled || !nextDisabled) && (
        <div className={styles.controls}>
          <Clickable
            data-testid="previous-mention-button"
            onClick={onClickPrevious}
            disabled={previousDisabled}
          >
            <PreviousMention />
          </Clickable>
          <Clickable
            data-testid="next-mention-button"
            onClick={onClickNext}
            disabled={nextDisabled}
          >
            <NextMention />
          </Clickable>
        </div>
      )}
    </div>
  );
};

export default PlayButtonWithControls;
